import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: '/zczxjy',
        name: 'zczxjy',
        component: () =>
            import ('@/components/zczxjy.vue'),
    },
    {
        path: '/tzlytkn',
        name: 'tzlytkn',
        component: () =>
            import ('@/components/tzlytkn.vue'),
    },
    {
        path: '/2021Q2alcb',
        name: '2021Q2alcb',
        component: () =>
            import ('@/components/2021Q2alcb.vue'),
    },
    {
        path: '/2021Q2jdcb',
        name: '2021Q2jdcb',
        component: () =>
            import ('@/components/2021Q2jdcb.vue'),
    },
    {
        path: '/2021Q2pddcb',
        name: '2021Q2pddcb',
        component: () =>
            import ('@/components/2021Q2pddcb.vue'),
    },
    {
        path: '/2021Q2jdjkcb',
        name: '2021Q2jdjkcb',
        component: () =>
            import ('@/components/2021Q2jdjkcb.vue'),
    },
    {
        path: '/2021Q2tcylcb',
        name: '2021Q2tcylcb',
        component: () =>
            import ('@/components/2021Q2tcylcb.vue'),
    },
    {
        path: '/2021Q2payscb',
        name: '2021Q2payscb',
        component: () =>
            import ('@/components/2021Q2payscb.vue'),
    },
    {
        path: '/2021symxcb',
        name: '2021symxcb',
        component: () =>
            import ('@/components/2021symxcb.vue'),
    },
    {
        path: '/alnyg',
        name: 'alnyg',
        component: () =>
            import ('@/components/alnyg.vue'),
    },
    {
        path: '/qdbys',
        name: 'qdbys',
        component: () =>
            import ('@/components/qdbys.vue'),
    },
    {
        path: '/jaydcx',
        name: 'jaydcx',
        component: () =>
            import ('@/components/jaydcx.vue'),
    },
    {
        path: '/yqchdjk',
        name: 'yqchdjk',
        component: () =>
            import ('@/components/yqchdjk.vue'),
    },
    {
        path: '/dywm',
        name: 'dywm',
        component: () =>
            import ('@/components/dywm.vue'),
    },
    {
        path: '/bdbl',
        name: 'bdbl',
        component: () =>
            import ('@/components/bdbl.vue'),
    },
    {
        path: '/vippl',
        name: 'vippl',
        component: () =>
            import ('@/components/vippl.vue'),
    },
    {
        path: '/kxp',
        name: 'kxp',
        component: () =>
            import ('@/components/kxp.vue'),
    },
    {
        path: '/hsmy',
        name: 'hsmy',
        component: () =>
            import ('@/components/hsmy.vue'),
    },
    {
        path: '/zgg',
        name: 'zgg',
        component: () =>
            import ('@/components/zgg.vue'),
    },
    {
        path: '/qqjy',
        name: 'qqjy',
        component: () =>
            import ('@/components/qqjy.vue'),
    },
    {
        path: '/818ds',
        name: '818ds',
        component: () =>
            import ('@/components/818ds.vue'),
    },
    {
        path: '/2021q2lsds',
        name: '2021q2lsds',
        component: () =>
            import ('@/components/2021q2lsds.vue'),
    },
    {
        path: '/ymx',
        name: 'ymx',
        component: () =>
            import ('@/components/ymx.vue'),
    },
    {
        path: '/alyxl',
        name: 'alyxl',
        component: () =>
            import ('@/components/alyxl.vue'),
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

export default router